'use strict';

function CompanyGroupUserService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/groups/:groupId/users/:userId');
}

angular.module('dokiv')
  .factory('CompanyGroupUserService', ['$resource', 'config', CompanyGroupUserService]);




//////////////////
// WEBPACK FOOTER
// ./scripts/company/groups/CompanyGroupUserService.js
// module id = 14
// module chunks = 0